<div class="search-dropdown" (scroll)="onDropdownScroll($event)">
  @if (results().length) {
    @for (result of filteredResults(); track $index) {
      @switch (result.type) {
        @case ('category') {
          <app-header-search-link [title]="result.entry['title']" icon="circle-information" subtitle="header.search.types.category" (clicked)="onClickCategory(result)" />
        }
        @default {
          <app-header-search-item [type]="result.type" [item]="result.entry" [countryFilter]="countryFilter()" [isExpanded]="results().length <= 1" />
        }
      }
    }
    @if (hasFaqResult()) {
      <app-header-search-link
        [title]="('header.search.faq-notice' | translate) + ': ' + (searchTerm() ?? '')"
        icon="circle-help"
        subtitle="header.search.types.faq"
        (clicked)="onClickFaqNotice()"
      />
    }
  } @else {
    <div class="no-results">
      {{ 'header.search.no-results' | translate }}
    </div>
  }
  @if (isSearching() || isAutoLoading()) {
    <app-loading-indicator />
  }
</div>
